// src/data/RoleConfig.js

// ==============================================================================
// 1. DEFINITIONS (DO NOT DELETE)
// ==============================================================================

export const PROFILE_WIDGETS = {
    WALLET_LITE: 'wallet_lite',       
    WALLET_PRO: 'wallet_pro',         
    TRADING_PULSE: 'trading_pulse',   
    RISK_GAUGE: 'risk_gauge',         
    JOURNEY_TRACKER: 'journey',       
    AGENT_PERF: 'agent_perf',         
    NETWORK_TREE: 'network_tree',     
    QUICK_ACTIONS: 'quick_actions',   
    ADMIN_AUDIT: 'admin_audit',       
    BANKING_CARD: 'banking_card',     
    DETAILS_PANE: 'details_pane',
    ACTIVITY_FEED: 'activity_feed',
    QUICK_NOTES: 'quick_notes',
    MARKETING_PULSE: 'marketing_pulse'
};

export const DASHBOARD_WIDGETS = {
    // Core Widgets
    MY_PERFORMANCE: 'my_perf',        
    CONTACT_QUEUE: 'contact_queue',   
    TICKET_QUEUE: 'ticket_queue',     
    SLA_ALERTS: 'sla_alerts',         
    LIVE_FLOOR: 'live_floor',         
    TEAM_LEADERBOARD: 'team_board',   
    DEPOSIT_TICKER: 'dep_ticker',     
    STAFF_REPORTS: 'staff_reports',
    
    // New Additions
    STAFF_ROTA: 'staff_rota',
    KYC_QUEUE: 'kyc_queue',
    MARKET_EVENTS: 'market_events',
    
    // Hybrid Widgets
    HYBRID_UNIFIED: 'hybrid_unified',
    COMPLETED_WORK: 'completed_work',
    
    // Support Lead Widgets
    REVIEW_CALENDAR: 'review_calendar'
};

export const PERMISSIONS = {
    CAN_EDIT_PII: 'can_edit_pii',
    CAN_APPROVE_DOCS: 'can_approve_docs',
    CAN_GIVE_BONUS: 'can_give_bonus',
    CAN_DELETE_CLIENT: 'can_delete_client',
    CAN_EXPORT_DATA: 'can_export_data',       
    CAN_VIEW_STAFF_PERF: 'can_view_staff_perf' 
};

// ==============================================================================
// 2. THE MASTER ROLE MATRIX
// ==============================================================================

export const ROLE_CONFIG = {
    
    // --- SALES DEPARTMENT ---
    'Sales_L1': {
        label: 'Junior Sales Agent',
        profileLayout: [
            PROFILE_WIDGETS.JOURNEY_TRACKER, 
            
            // ROW 1: Financials & Risk
            PROFILE_WIDGETS.WALLET_LITE,     
            PROFILE_WIDGETS.BANKING_CARD,    
            PROFILE_WIDGETS.RISK_GAUGE,      
            
            // ROW 2: Context & Activity
            PROFILE_WIDGETS.QUICK_NOTES,
            PROFILE_WIDGETS.ACTIVITY_FEED,
            PROFILE_WIDGETS.AGENT_PERF,      // <-- THE FIX: Assigned Agent Widget is now 3rd!
            
            // ROW 3+
            PROFILE_WIDGETS.DETAILS_PANE,    
            PROFILE_WIDGETS.QUICK_ACTIONS
        ],
        dashboardLayout: [
            DASHBOARD_WIDGETS.MY_PERFORMANCE, 
            DASHBOARD_WIDGETS.CONTACT_QUEUE, 
            DASHBOARD_WIDGETS.MARKET_EVENTS, 
            DASHBOARD_WIDGETS.HYBRID_UNIFIED
        ], 
        permissions: []
    },
    'Sales_Manager': {
        label: 'Head of Sales',
        profileLayout: [
            PROFILE_WIDGETS.JOURNEY_TRACKER, 
            
            // ROW 1
            PROFILE_WIDGETS.WALLET_PRO,      
            PROFILE_WIDGETS.BANKING_CARD,    
            PROFILE_WIDGETS.RISK_GAUGE,      
            
            // ROW 2
            PROFILE_WIDGETS.QUICK_NOTES,
            PROFILE_WIDGETS.ACTIVITY_FEED,
            PROFILE_WIDGETS.AGENT_PERF,      // <-- THE FIX
            
            // ROW 3+
            PROFILE_WIDGETS.DETAILS_PANE,    
            PROFILE_WIDGETS.MARKETING_PULSE
        ],
        dashboardLayout: [
            DASHBOARD_WIDGETS.TEAM_LEADERBOARD, 
            DASHBOARD_WIDGETS.LIVE_FLOOR, 
            DASHBOARD_WIDGETS.STAFF_ROTA, 
            DASHBOARD_WIDGETS.DEPOSIT_TICKER, 
            DASHBOARD_WIDGETS.STAFF_REPORTS
        ], 
        permissions: [PERMISSIONS.CAN_GIVE_BONUS, PERMISSIONS.CAN_VIEW_STAFF_PERF, PERMISSIONS.CAN_EXPORT_DATA]
    },

    // --- HYBRID ROLES ---
    'Hybrid_Agent': {
        label: 'Sales & Support Associate',
        profileLayout: [
            PROFILE_WIDGETS.JOURNEY_TRACKER,
            
            // ROW 1
            PROFILE_WIDGETS.WALLET_LITE, 
            PROFILE_WIDGETS.BANKING_CARD,    
            PROFILE_WIDGETS.RISK_GAUGE, 
            
            // ROW 2
            PROFILE_WIDGETS.QUICK_NOTES,
            PROFILE_WIDGETS.ACTIVITY_FEED,   
            PROFILE_WIDGETS.AGENT_PERF,      // <-- THE FIX
            
            // ROW 3+
            PROFILE_WIDGETS.DETAILS_PANE,    
            PROFILE_WIDGETS.QUICK_ACTIONS
        ],
        dashboardLayout: [
            DASHBOARD_WIDGETS.TICKET_QUEUE,    
            DASHBOARD_WIDGETS.KYC_QUEUE,       
            DASHBOARD_WIDGETS.CONTACT_QUEUE,   
            DASHBOARD_WIDGETS.HYBRID_UNIFIED
        ],
        permissions: [] 
    },

    // --- SUPPORT DEPARTMENT ---
    'Support_L1': {
        label: 'Customer Support',
        profileLayout: [
            PROFILE_WIDGETS.JOURNEY_TRACKER, 
            
            // ROW 1
            PROFILE_WIDGETS.WALLET_LITE,     
            PROFILE_WIDGETS.BANKING_CARD,    
            PROFILE_WIDGETS.RISK_GAUGE,      
            
            // ROW 2
            PROFILE_WIDGETS.QUICK_NOTES,
            PROFILE_WIDGETS.ACTIVITY_FEED,   
            PROFILE_WIDGETS.AGENT_PERF,      // <-- THE FIX
            
            // ROW 3+
            PROFILE_WIDGETS.DETAILS_PANE,    
            PROFILE_WIDGETS.QUICK_ACTIONS
        ],
        dashboardLayout: [
            DASHBOARD_WIDGETS.TICKET_QUEUE, 
            DASHBOARD_WIDGETS.KYC_QUEUE, 
            DASHBOARD_WIDGETS.HYBRID_UNIFIED
        ], 
        permissions: []
    },
    'Support_Manager': {
        label: 'Support Lead',
        profileLayout: [
            // ROW 1
            PROFILE_WIDGETS.WALLET_PRO,      
            PROFILE_WIDGETS.BANKING_CARD,
            PROFILE_WIDGETS.RISK_GAUGE, 
            
            // ROW 2
            PROFILE_WIDGETS.QUICK_NOTES,
            PROFILE_WIDGETS.ACTIVITY_FEED,
            PROFILE_WIDGETS.AGENT_PERF,      // <-- THE FIX
            
            // ROW 3+
            PROFILE_WIDGETS.DETAILS_PANE, 
            PROFILE_WIDGETS.ADMIN_AUDIT
        ],
        dashboardLayout: [
            DASHBOARD_WIDGETS.LIVE_FLOOR, 
            DASHBOARD_WIDGETS.TICKET_QUEUE, 
            DASHBOARD_WIDGETS.KYC_QUEUE, 
            DASHBOARD_WIDGETS.STAFF_ROTA, 
            DASHBOARD_WIDGETS.REVIEW_CALENDAR, 
            DASHBOARD_WIDGETS.COMPLETED_WORK 
        ], 
        permissions: [PERMISSIONS.CAN_APPROVE_DOCS, PERMISSIONS.CAN_VIEW_STAFF_PERF, PERMISSIONS.CAN_EXPORT_DATA]
    },
    
    // --- MANAGEMENT ---
    'Admin': {
        label: 'System Administrator',
        profileLayout: [
            PROFILE_WIDGETS.JOURNEY_TRACKER, 
            
            // ROW 1
            PROFILE_WIDGETS.WALLET_PRO,      
            PROFILE_WIDGETS.BANKING_CARD,    
            PROFILE_WIDGETS.RISK_GAUGE,      
            
            // ROW 2
            PROFILE_WIDGETS.QUICK_NOTES,     
            PROFILE_WIDGETS.ACTIVITY_FEED,   
            PROFILE_WIDGETS.AGENT_PERF,      // <-- THE FIX
            
            // ROW 3+
            PROFILE_WIDGETS.DETAILS_PANE,    
            PROFILE_WIDGETS.ADMIN_AUDIT
        ],
        dashboardLayout: Object.values(DASHBOARD_WIDGETS), 
        permissions: Object.values(PERMISSIONS)
    }
};

// ==============================================================================
// 3. HELPER EXPORTS
// ==============================================================================
export const getRoleConfig = (roleKey) => {
    return ROLE_CONFIG[roleKey] || ROLE_CONFIG['Sales_L1'];
};